import Modal from '@components/Modal.vue';
import Attach from '@tools/attach';
import { URL_RESETTING_PASSWORD } from '@tools/routes/routes';
import TwigFormValidator from '@tools/twig-form/validator';
import translation from '@elements/translation';
import requests from '@tools/requests-mixin';
import eventBus from '@tools/event-bus';

/**
 * Resetting Password Modal Component
 * This component use the modal component as a child.
 * It displays the missing email form for the user to fill.
 */
export default {
  template: '#user-modal-component',
  components: {
    Modal,
  },
  props: [ 'isOpened' ],
  mixins: [ translation, requests ],
  delimiters: [ '${', '}' ],
  data() {
    return {
      htmlBody: '',
      modalTitle: '',
    };
  },
  methods: {
    switchTo(newModalName) {
      this.htmlBody = '';
      this.modalTitle = '';
      eventBus.dispatchEvent(new CustomEvent('switch-from-to-modal', {
        detail: {
          oldModalName: 'ResettingPassword',
          newModalName,
        },
      }));
    },
    close() {
      this.htmlBody = '';
      this.$emit('close');
    },
    initForm() {
      this.$nextTick(() => {
        const validator = new TwigFormValidator({
          formSelector: '#form_resetting',
          rules: {
            _username: [ 'required', 'email' ],
          },
          onSuccess: (event) => {
            Attach.asyncSubmit(event)
              .then((result) => {
                // Bad method but the html should be different so that the modal
                // is re-rendered (this.$forceUpdate() doesn't do the job)
                this.htmlBody = `${result.data}<!--${Date.now()}-->`;
                this.initForm();

                this.$nextTick(() => {
                  if (document.getElementById('unknown-email-register')) {
                    Attach.onClickEvent('unknown-email-register', () => {
                      this.switchTo('RegisterChoice');
                    });
                  }
                  if (document.getElementById('resetting-password-close-button')) {
                    Attach.onClickEvent('resetting-password-close-button', () => {
                      this.close();
                    });
                  }
                  if (document.getElementById('account-associated')) {
                    Attach.onClickEvent('account-associated', () => {
                      this.switchTo('Login');
                    });
                  }
                });
              });
          },
        });
        validator.init();
      });
    },
  },
  watch: {
    isOpened(newVal) {
      if (!newVal) {
        return;
      }

      this.modalTitle = this.trans('form.resetting_password.modal_title');

      this.get(URL_RESETTING_PASSWORD).then((response) => {
        this.htmlBody = response.data;
        this.initForm();
      }).catch(() => {
        this.close();
      });
    },
  },
};
